import styled from '@emotion/styled/macro'
import { AutoStack, FlexSpinner } from 'components'
import {
  UserPickerAdvanced,
  WorkerPickerAdvanced,
} from 'components/PersonPicker'
import { themeColor } from 'mixins'
import { IPersonaProps, PrimaryButton, Text } from 'office-ui-fabric-react'
import * as React from 'react'
import { CSVLink } from 'react-csv'
import {
  useEvaluateProvingLazyQuery,
  useEvaluateWikiLazyQuery,
} from './EvaluatePersonForm.generated'

const StyledCSVLink = styled(CSVLink)`
  color: ${themeColor('themePrimary')};
`

export const EvaluatePersonForm: React.FC = () => {
  const [selection, setSelection] = React.useState()
  const [workerSelection, setWorkerSelection] = React.useState()
  const [evaluateProvings, { loading, data }] = useEvaluateProvingLazyQuery()
  const [
    evaluateProvingsForWorker,
    { loading: workerLoading, data: workerData },
  ] = useEvaluateProvingLazyQuery()
  const [evaluateWikis, { loading: loadingWikis, data: dataWikis }] =
    useEvaluateWikiLazyQuery()

  const [evaluatePersonClicked, setEvaluatePersonClicked] =
    React.useState(false)
  const [evaluateWorkerClicked, setEvaluateWorkerClicked] =
    React.useState(false)

  const csvContent = [['title', 'typeName']]
  const workerCsvContent = [['title', 'typeName']]
  const provings = (data && data.evaluateProving) || []
  const wikis = (dataWikis && dataWikis.evaluateWiki) || []
  const workerProvings = (workerData && workerData.evaluateProving) || []
  provings.forEach((p) => csvContent.push([p.id, p.__typename || '']))
  workerProvings.forEach((p) =>
    workerCsvContent.push([p.id, p.__typename || ''])
  )
  wikis.forEach((w) => csvContent.push([w.topic, w.__typename || '']))
  return (
    <>
      <AutoStack tokens={{ childrenGap: 8 }}>
        <Text variant="xLarge" as="h2">
          Person
        </Text>
        <UserPickerAdvanced
          itemLimit={1}
          onChange={(items?: IPersonaProps[]) => {
            if (items && items[0]) {
              setSelection(items[0])
              setEvaluatePersonClicked(false)
            }
          }}
        />
        <PrimaryButton
          text="Person Auswerten"
          onClick={() => {
            evaluateProvings({
              variables: {
                person: selection && selection.userId ? selection.userId : '',
              },
            })
            evaluateWikis({
              variables: {
                person: selection && selection.userId ? selection.userId : '',
              },
            })
            setEvaluatePersonClicked(true)
          }}
        />
      </AutoStack>
      <FlexSpinner loading={loading && loadingWikis}>
        {csvContent.length > 1 && evaluatePersonClicked ? (
          <StyledCSVLink
            data={csvContent}
            filename={`Auswertung ${selection ? selection.text : ''}`}
            target="_blank"
          >
            Auswertung herunterladen (.CSV)
          </StyledCSVLink>
        ) : selection && evaluatePersonClicked ? (
          <Text>{`Über die Person ${selection.text} wurden keine Daten gefunden`}</Text>
        ) : (
          ''
        )}
      </FlexSpinner>
      <br />
      <AutoStack tokens={{ childrenGap: 8 }}>
        <Text variant="xLarge" as="h2">
          Werkstattmitarbeiter
        </Text>
        <WorkerPickerAdvanced
          itemLimit={1}
          onChange={(items?: IPersonaProps[]) => {
            if (items && items[0]) {
              setWorkerSelection(items[0])
              setEvaluateWorkerClicked(false)
            }
          }}
        />
        <PrimaryButton
          text="Werkstattmitarbeiter auswerten"
          onClick={() => {
            evaluateProvingsForWorker({
              variables: {
                person:
                  workerSelection && workerSelection.userId
                    ? workerSelection.userId
                    : '',
              },
            })
            setEvaluateWorkerClicked(true)
          }}
        />
      </AutoStack>
      <FlexSpinner loading={workerLoading}>
        {workerCsvContent.length > 1 && evaluateWorkerClicked ? (
          <StyledCSVLink
            data={workerCsvContent}
            filename={`Auswertung ${
              workerSelection ? workerSelection.text : ''
            }`}
            target="_blank"
          >
            Auswertung herunterladen (.CSV)
          </StyledCSVLink>
        ) : workerSelection && evaluateWorkerClicked ? (
          <Text>{`Über den Werkstattmitarbeiter ${workerSelection.text} wurden keine Daten gefunden`}</Text>
        ) : (
          ''
        )}
      </FlexSpinner>
    </>
  )
}
